import { Component, OnDestroy, OnInit } from '@angular/core';
import { DbService } from "../../services/db.service";
import { Image } from "../../models/Image";

interface PendingPhoto {
    image: Image;
    preview: string;
    sending: boolean;
    confirmDelete: boolean;
}

/**
 * Fotos que siguen en la cola del móvil. El xofer puede reenviar una sin esperar a la tanda de cada
 * minuto, o borrarla si se ha quedado atascada (p. ej. un POD que el servidor rechaza siempre).
 */
@Component({
    selector: 'app-pending-photos',
    templateUrl: './pending-photos.component.html',
    styleUrls: ['./pending-photos.component.scss'],
    standalone: false
})
export class PendingPhotosComponent implements OnInit, OnDestroy {

    name = "Fotos pendientes";

    photos: PendingPhoto[] = [];
    loaded: boolean = false;
    message: string = "";

    private objectUrls: string[] = [];

    constructor(public dbService: DbService) {
    }

    async ngOnInit() {
        await this.load();
    }

    ngOnDestroy() {
        this.revokePreviews();
    }

    typeLabel(image: Image): string {
        if (image.tipoFoto === "finalitzacioAlbara") return "POD";
        if (image.tipoFoto === "albaranFoto") return "Foto de punto";

        return image.tipoFoto;
    }

    async resend(photo: PendingPhoto) {
        photo.sending = true;
        this.message = "";

        try {
            await this.dbService.resendImage(photo.image);
            this.message = "Foto enviada correctamente.";
        } catch (error) {
            this.message = "No se ha podido enviar: " + this.dbService.describeError(error);
        }

        await this.load();
    }

    async remove(photo: PendingPhoto) {
        await this.dbService.deleteImage(photo.image);
        this.message = "Foto eliminada de la cola.";
        await this.load();
    }

    private async load() {
        this.revokePreviews();

        const images = await this.dbService.existsImages();
        const photos: PendingPhoto[] = [];
        for (const image of images) {
            photos.push({
                image: image,
                preview: await this.preview(image),
                sending: false,
                confirmDelete: false,
            });
        }
        this.photos = photos;
        this.loaded = true;
    }

    // El POD se guarda en base64; las fotos de punto, como bytes que se leen de una en una
    private async preview(image: Image): Promise<string> {
        if (image.base64) return 'data:image/jpeg;base64,' + image.base64;

        try {
            const url = URL.createObjectURL(await this.dbService.readFile(image));
            this.objectUrls.push(url);
            return url;
        } catch (error) {
            return "";
        }
    }

    private revokePreviews() {
        this.objectUrls.forEach(url => URL.revokeObjectURL(url));
        this.objectUrls = [];
    }
}
